import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import 'fslightbox'

Alpine.plugin(collapse)

/**
 * 1. Загружаем STORES (eager!)
 * Они должны регистрироваться ДО alpine:init
 */
const stores = import.meta.glob('./stores/*.js', { eager: true })

for (const path in stores) {
    const register = stores[path]?.default

    if (typeof register === 'function') {
        register(Alpine)
    }
}

/**
 * 2. Загружаем COMPONENTS
 */
const components = import.meta.glob('./components/*.js', { eager: true })

document.addEventListener('alpine:init', () => {

    /**
     * Глобальный store app
     */
    const app = window.__APP__ || {}

    Alpine.store('app', {
        csrf: app.csrf ?? null,
        routes: app.routes ?? {},
    })

    /**
     * Регистрация компонентов
     */
    for (const path in components) {
        const name = path
            .replace('./components/', '')
            .replace('.js', '')

        Alpine.data(name, components[path].default)
    }
})

/**
 * 3. Старт Alpine
 */
window.Alpine = Alpine
Alpine.start()
